(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-descripcion-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){ if(!root||root.dataset.gcInit) return; root.dataset.gcInit='1';
  [].forEach.call(root.querySelectorAll('[data-anat2]'),function(a2){
    var pins=a2.querySelectorAll('[data-pin]'), tr=a2.querySelector('[data-dtrack]'), cards=tr?tr.querySelectorAll('[data-card]'):[];
    function pick(i){
      [].forEach.call(pins,function(p,k){ var on=k===i; p.style.background=on?'#FFF':'#1A1A1A'; p.style.color=on?'#1A1A1A':'#FFF'; });
      [].forEach.call(cards,function(c,k){ c.style.boxShadow=k===i?'0 0 0 2px #1A1A1A':'none'; });
      var c=cards[i]; if(!c) return;
      if(tr.scrollWidth>tr.clientWidth+4) tr.scrollTo({left:c.offsetLeft-cards[0].offsetLeft,behavior:'smooth'});
      else if(c.getBoundingClientRect().top<0||c.getBoundingClientRect().bottom>innerHeight) window.scrollBy({top:c.getBoundingClientRect().top-120,behavior:'smooth'});
    }
    [].forEach.call(pins,function(p){ p.addEventListener('click',function(){ pick(+p.getAttribute('data-pin')); }); });
    [].forEach.call(cards,function(c,k){ c.addEventListener('click',function(){ pick(k); }); });
  });


  [].forEach.call(root.querySelectorAll('details'),function(d){
    d.addEventListener('toggle',function(){
      var a=d.querySelector('[data-arrow]'), c=d.querySelector('[data-chev]');
      if(a) a.style.background=d.open?'#1A1A1A':'#FFF';
      if(c){ c.style.transform='rotate('+(d.open?-135:45)+'deg) translate(-1px,-1px)';
        c.style.borderRightColor=c.style.borderBottomColor=d.open?'#FFF':'#1A1A1A'; }
    });
  });
  var slides=root.querySelectorAll('[data-slide]'), tabs=root.querySelectorAll('[data-tab]'), auto, cur=0;
  function select(i){
    cur=i;
    [].forEach.call(slides,function(im,k){ im.style.opacity=k===i?'1':'0'; });
    [].forEach.call(tabs,function(t,k){
      var on=k===i, b=t.querySelector('[data-body]');
      t.style.background=on?'#FAF8F3':'transparent'; t.setAttribute('aria-pressed',on?'true':'false');
      b.style.maxHeight=on?'200px':'0'; b.style.opacity=on?'1':'0';
    });
  }
  [].forEach.call(tabs,function(t,i){ t.addEventListener('click',function(){ clearInterval(auto); select(i); }); });
  var wrap=root.querySelector('[data-moments]');
  if(wrap&&'IntersectionObserver' in window&&!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
    new IntersectionObserver(function(es){ clearInterval(auto);
      if(es[0].isIntersecting) auto=setInterval(function(){ select((cur+1)%tabs.length); },4500);
    },{threshold:.4}).observe(wrap);
  }
  var track=root.querySelector('[data-track]'), dots=root.querySelector('[data-dots]'), bar=root.querySelector('[data-bar]');
  if(!track) return;
  var cards=[].slice.call(track.children), dest=null, settle, raf;
  function target(i){ return cards[i].offsetLeft-cards[0].offsetLeft; }
  function nearest(){ var best=0,bd=1e9; cards.forEach(function(c,i){ var d=Math.abs(target(i)-track.scrollLeft); if(d<bd){bd=d;best=i;} }); return best; }
  if(dots) cards.forEach(function(_,i){
    var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Ir a la reseña '+(i+1));
    b.style.cssText='width:8px;height:8px;border-radius:50%;border:0;padding:0;cursor:pointer;background:rgba(83,93,83,.25);transition:background .25s,transform .25s';
    b.addEventListener('click',function(){ track.scrollTo({left:target(i),behavior:'smooth'}); });
    dots.appendChild(b);
  });
  function paint(){ var best=nearest();
    if(bar){ var mx=track.scrollWidth-track.clientWidth; bar.style.width=Math.max(20,Math.round((mx>0?track.scrollLeft/mx:1)*100))+'%'; }
    if(dots) [].forEach.call(dots.children,function(b,i){ b.style.background=i===best?'#535D53':'rgba(83,93,83,.25)'; b.style.transform=i===best?'scale(1.35)':'none'; }); }
  function go(dir){ var base=dest===null?nearest():dest; dest=Math.max(0,Math.min(cards.length-1,base+dir));
    track.scrollTo({left:target(dest),behavior:'smooth'}); clearTimeout(settle); settle=setTimeout(function(){dest=null;},700); }
  root.querySelector('[data-prev]').addEventListener('click',function(){go(-1);});
  root.querySelector('[data-next]').addEventListener('click',function(){go(1);});
  track.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(function(){ raf=0; paint(); }); },{passive:true});
  paint();
}
  function boot(){ document.querySelectorAll('.gc-pdp').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('.gc-pdp'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();
})();
